var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", { staticClass: "mb-1" }, [
      _vm._v(_vm._s(_vm.$t("cancellation.product_policy_title"))),
    ]),
    _c("small", { staticClass: "text-muted d-block mb-3" }, [
      _vm._v(_vm._s(_vm.$t("cancellation.product_policy_hint"))),
    ]),
    _c("div", { staticClass: "vx-row" }, [
      _c(
        "div",
        { staticClass: "vx-col lg:w-1/2 w-full" },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("cancellation.policy"),
                "label-for": "product_policy",
              },
            },
            [
              _c(
                "v-select",
                {
                  staticClass: "w-full",
                  attrs: {
                    id: "product_policy",
                    options: _vm.policyOptions,
                    reduce: function (opt) {
                      return opt.id
                    },
                    label: "label",
                    placeholder: _vm.$t("cancellation.product_policy_inherit"),
                    clearable: true,
                  },
                  on: { input: _vm.save },
                  model: {
                    value: _vm.selectedPolicyId,
                    callback: function ($$v) {
                      _vm.selectedPolicyId = $$v
                    },
                    expression: "selectedPolicyId",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "no-options" }, slot: "no-options" },
                    [_vm._v(_vm._s(_vm.$t("cancellation.product_policy_none")))]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.selectedPolicy
            ? _c("div", { staticClass: "border rounded p-1 mt-1" }, [
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.version"))),
                  ]),
                  _vm.selectedPolicy.active_version
                    ? _c("small", [
                        _vm._v(
                          " v" +
                            _vm._s(_vm.selectedPolicy.active_version.version) +
                            " · " +
                            _vm._s(_vm.$t("cancellation.version_status_.AC")) +
                            " "
                        ),
                      ])
                    : _c("small", { staticClass: "text-warning" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cancellation.product_policy_no_active")
                          )
                        ),
                      ]),
                ]),
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.applied_to"))),
                  ]),
                  _c("small", [
                    _vm._v(_vm._s(_vm.selectedPolicy.applies_to || "—")),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.establishments"))),
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.selectedPolicy.establishment_names || "—")
                    ),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "border rounded p-1 mt-1" }, [
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    _vm._s(_vm.$t("cancellation.product_policy_inherit_hint"))
                  ),
                ]),
              ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }